module.exports = __webpack_public_path__ + "img/quotes-3.3433e7c5.webp";